import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-4RW4GG2E78";
let initialized = false;

function hasAnalyticsConsent(): boolean {
  return localStorage.getItem("cookieAnalytics") === "1";
}

export function initAnalytics(): void {
  if (!hasAnalyticsConsent() || initialized) return;
  ReactGA.initialize(GA_MEASUREMENT_ID);
  initialized = true;
}

export function trackPageView(path?: string): void {
  if (!hasAnalyticsConsent()) return;
  if (!initialized) {
    initAnalytics();
  }
  if (initialized) {
    ReactGA.send({
      hitType: "pageview",
      page: path ?? window.location.pathname,
    });
  }
}
